import { Controller } from '@hotwired/stimulus'

/**
 * 非同期フレーム読み込みコントローラー
 *
 * fetch APIを使用してHTMLを非同期で取得し、要素内に挿入する。
 * ページの初期表示を高速化するため、Below The Foldのコンテンツを
 * 非同期で読み込む際に使用する。
 *
 * 使用例:
 * ```slim
 * div data-controller="async-frame"
 *     data-async-frame-url-value="/path/to/content"
 *   .turbo-frame-loading
 *     .turbo-frame-loading__spinner
 *     span.turbo-frame-loading__text 読み込み中...
 * ```
 */
export default class extends Controller {
  static values = { url: String }

  connect () {
    if (this.urlValue) {
      this.load()
    }
  }

  async load () {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html',
        },
      })
      if (response.ok) {
        const html = await response.text()
        this.element.innerHTML = html
      } else {
        // eslint-disable-next-line no-console
        console.error('非同期フレーム読み込みエラー:', response.status, response.statusText)
        this.showError()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('非同期フレーム読み込みエラー:', error)
      this.showError()
    }
  }

  /**
   * エラー時にローディングスピナーを非表示にする
   */
  showError () {
    const loadingElement = this.element.querySelector('.turbo-frame-loading')
    if (loadingElement) {
      loadingElement.style.display = 'none'
    }
  }
}
